// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"598b1707","455":"819d9e85","977":"7322acfe"}[chunkId] + ".chunk.js";
};